import { createSpinner } from './utils';

// Open password form
export const openPasswordForm = ( button ) => {

	const parent = button.closest('li');
	if (!parent) return;

	const form = parent.querySelector('.post-password--wrapper');
	const input = parent.querySelector('input[type="password"]');

	resetPasswordForm();

	button.classList.add('focus');

	if (form) {
		form.style.display = "block";
	}

	if (input) {
		input.focus();
	}

	document.documentElement.classList.add('no-scroll');
}



// Close password form
export const closePasswordForm = () => {
	resetPasswordForm();
};



// Reset all password forms
export const resetPasswordForm = () => {

	const formsWrapperAll = document.querySelectorAll('.post-password--wrapper');
	const focusElementsAll = document.querySelectorAll('.album-thumb.is-protected.focus');

	formsWrapperAll.forEach( (el) => {
		const errorMsg = el.querySelector('.error-password');
		const input = el.querySelector('input[type="password"]');
		el.style.display = 'none';

		if (errorMsg) {
			errorMsg.textContent = "";
		}

		if (input) {
			input.value = "";
		}

	});

	focusElementsAll.forEach( (el) => {
		el.classList.remove('focus');
	});

	document.documentElement.classList.remove('no-scroll');
}



// Attach event listeners
export const theme_initPasswordForm = () => {

	document.addEventListener( "click", (e) => {

		const openFormButton = e.target.closest('a.album-thumb.is-protected');
		const closeFormButton = e.target.closest('button.close-password');

		if (openFormButton) {
			e.preventDefault();
			openPasswordForm(openFormButton);
		}

		if (closeFormButton) {
			e.preventDefault();
			closePasswordForm(closeFormButton);
		}
	});

}



export function theme_passwordFormSubmit() {

	const formSubmitHandler = async (form) => {

		const wrapper = document.querySelector('.ebert__grid');
		const formInputs = document.querySelectorAll('input[name="post_id"]');
		const loading = createSpinner();

		let post_ids = [];
		if ( formInputs ) {
			formInputs.forEach( (el) => {
				post_ids.push( el.value );
			});
		}

		if ( ! post_ids ) {
			return;
		}

		document.body.appendChild( loading );
		const errorWrapper = form.querySelector('.error-password');
		errorWrapper.textContent = '';

		const data = {
			'action': 'postpass',
			'post_id': form.post_id.value,
			'ids': post_ids,
			'security': data_params.ajaxnonce,
			'password': form.post_password.value
		};

		const params = new URLSearchParams();
		for ( const [key, value] of Object.entries(data) ) {
			params.append(key, value);
		}

		try {

			const response = await fetch( data_params.ajaxurl, {
				method: 'POST',
				headers: {
					'Content-Type': 'application/x-www-form-urlencoded'
				},
				body: params
			});

			if ( ! response.ok ) {

				// Try to parse JSON error response
				let errorMessage = `HTTP error! Status: ${response.status}`;

				try {
					const errorData = await response.json();
					if (errorData?.data?.message) {
						errorMessage = errorData.data.message;
					}
				}
				catch (_) {
					// ignore parse error, fallback to generic
				}
				throw new Error(errorMessage);
			}

			const result = await response.json();

			if ( result ) {

				if ( result.data.posts ) {

					result.data.posts.forEach( (post) => {

						if ( !post.id || !post.html ) {
							return;
						}

						// find the reference element
						const currentPost = document.getElementById('post-' + post.id);
						const currentListItem = currentPost.closest('li');
						const prevListItem = currentListItem.previousSibling;
						const listItems = post.html;

						currentPost.querySelector('.title-prefix').innerHTML = result.data.icon;

						setTimeout( () => {

							// remove old element
							currentListItem.remove();

							// build a fragment from HTML strings
							const frag = document.createDocumentFragment();

							listItems.forEach(html => {
								const temp = document.createElement('div');
								temp.innerHTML = html.trim();		// parse string into real DOM nodes
								frag.append(...temp.childNodes);	// move all nodes into fragment
							});

							// insert new items after prevListItem or at the end of the grid
							if (prevListItem) {
								prevListItem.parentNode.insertBefore(frag, prevListItem.nextSibling);
							}
							else {
								wrapper.append(frag);
							}

						}, 1000);

					});

				}

				// Remove Form
				form.parentNode.remove();
				// Remove overflow hidden
				document.documentElement.classList.remove('no-scroll');

			}

		}
		catch ( error ) {
			// Error message to form
			errorWrapper.textContent = error.message;
		}
		finally {
			loading.remove();
		}

	};


	document.addEventListener( "submit", (e) => {

		const form = e.target.closest('form.post-password--form');

		if ( form ) {
			e.preventDefault();
			formSubmitHandler( form );
		}

	});

}
